import React, { useContext, useEffect, useRef, useState } from 'react'
import { Toolbar } from '@devexpress/dx-react-scheduler-material-ui';
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import GlobalContext from '../../GlobalContext';
import { RiPriceTag3Line, RiCheckLine, RiCloseLine, RiFilter2Line, RiEraserLine, RiLoopLeftFill } from 'react-icons/ri'
import { Col, Form, FormControl, InputGroup, Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle, Row, Tab, Tabs } from 'react-bootstrap'
import { useImmer } from 'use-immer';
import GoodSwitch from '../../components/GoodSwitch'
import TextContext from '../../TextContext';
import GoodNumber from '../../components/GoodNumber';
import ServiceContext from '../../ServiceContext';
import GoodCheck from '../../components/GoodCheck';
import { AiOutlineQuestionCircle } from 'react-icons/ai';
import UserFilterModal from './UserFilterModal';

const defCategories = [
]
const defaultCategory =
{
    ID: 0,
    cat_name: "nocategory",
    cat_apt: 0,
    cat_color: "#bbbbbbb4",
    cat_duration: 60
}
const getMinutes = (values) => {
    let hours = values.cat_duration_h
    let minutes = values.cat_duration_m
    // console.log(hours)
    // console.log(minutes)
    if (hours === null || hours === undefined || hours === Infinity || hours === NaN || !hours) {
        hours = 0
    } else {
        hours = parseInt(hours)
    }
    if (minutes === null || minutes === undefined || minutes === Infinity || minutes === NaN || !minutes) {
        minutes = 0
    } else {
        minutes = parseInt(minutes)
    }
    // console.log(hours)
    // console.log(minutes)
    const total = hours * 60 + minutes
    return total > 0 ? total : 1
}
const getDuration = (total) => {
    try {
        //console.log(total)
        const hours = Math.floor(total / 60)
        //console.log(hours)
        const minutes = total - (hours * 60)
        return [hours, minutes]
    } catch {
        return [0, 1]
    }
}

const defCatValues={
    cat_name: '',
    cat_apt: true,
    cat_color: "#cc2828",
    cat_price: 0,
    cat_duration_h: 1,
    cat_duration_m: 30,
    cat_prevent_apt: 0,
    cat_prevent_cr: 0,
    cat_global: 0
}

const CustomFlexibleSpace = () => {

    const globalContext = useContext(GlobalContext)
    const textContext = useContext(TextContext)
    const serviceContext = useContext(ServiceContext)
    const animatedComponents = makeAnimated();
    const [categoryOptions, setCategoryOptions] = useState(globalContext.get.categories.filter(cat => cat.ID != 0).map(cat => ({ label: cat.cat_name, value: cat.ID })))
    const [reloadCatCheck, setReloadCatCheck] = useState(true)
    const [options, setOptions] = useState([])
    const [showCat, setShowCat] = useState(false)
    const [showUserFilter, setShowUserFilter] = useState(false)
    const [activeTab, setActiveTab] = useState("add")
    const [resetColors, setResetColors] = useState(false)
    const [resetSwitch, setResetSwitch] = useState(false)
    const [catValues, setCatValues] = useImmer(defCatValues)
    const [catChecks, setCatCheks] = useImmer({
        touched: {
            ID: false,
            cat_name: false,
            cat_apt: false,
            cat_color: false,
            cat_duration_h: false,
            cat_duration_m: false,
            cat_prevent_apt: false,
            cat_prevent_cr: false,
            cat_global: false
        },
        check: {
            ID: (v) => { return true },
            cat_name: (v) => { return v.length > 0 && v.length < 21 && checkName(v, catValues, categoryOptions) },
            cat_apt: (v) => { return true },
            cat_prevent_apt: (v) => { return true },
            cat_prevent_cr: (v) => { return true },
            cat_color: (v) => { return true },
            cat_price: (v) => { return true },
            cat_duration_h: (v) => { return v >= 0 && v <= 23 },
            cat_duration_m: (v) => { return v >= 0 && v <= 59 },
            cat_global: (v) => { return true }
        },
        good: {
            ID: false,
            cat_name: false,
            cat_apt: false,
            cat_color: false,
            cat_duration_h: false,
            cat_duration_m: false,
            cat_prevent_apt: false,
            cat_prevent_cr: false,
            cat_global: false
        },
        bad: {
            ID: false,
            cat_name: false,
            cat_apt: false,
            cat_color: false,
            cat_duration_h: false,
            cat_duration_m: false,
            cat_prevent_apt: false,
            cat_prevent_cr: false,
            cat_global: false
        },
    })


    const colorRef = useRef("")

    const [selectedOption, setSelectedOption] = useState(undefined)
    const getOptions = () => {
        setOptions(globalContext.get.shops.map(sho => { return { label: sho.sho_name, value: sho.ID } }))
        if (!selectedOption && globalContext.get.Shop.sho_name) {
            setSelectedOption({ label: globalContext.get.Shop.sho_name, value: globalContext.get.Shop.ID })
        }
    }
    const checkForm = (values, check, setCheck, show = false) => {
        try {
            let pass = true
            Object.keys(values).forEach(k => {
                if (check.check[k](values[k])) {

                    if (show || check.touched[k]) {
                        setCheck(draft => { draft.good[k] = true })
                        setCheck(draft => { draft.bad[k] = false })
                    }
                } else {
                    // console.log(k, values[k])
                    pass = false

                    if (show || check.touched[k]) {
                        setCheck(draft => { draft.bad[k] = true })
                        setCheck(draft => { draft.good[k] = false })
                    }
                }

            })
            return pass
        } catch (e) {
            console.log('check error', e)
            return false
        }
    }
    const changeColor = async (e) => {

        try {
            document.getElementById(e.target.id).value = e.target.value;
            colorRef.current = e.target.value
        }
        catch {
            return
        }
    }
    const loadCatValues = (ID) => {
        const cat = globalContext.get.categories.filter(cat => cat.ID == ID)[0]
        const splitDuration = getDuration(cat.cat_duration)
        setCatValues({
            ID: ID,
            cat_name: cat.cat_name,
            cat_apt: cat.cat_apt,
            cat_color: cat.cat_color,
            cat_price: cat.cat_price,
            cat_duration_h: splitDuration[0],
            cat_duration_m: splitDuration[1],
            cat_prevent_apt: cat.cat_prevent_apt,
            cat_prevent_cr: cat.cat_prevent_cr,
            cat_global: cat.cat_global
        })
        setCatCheks({
            touched: {
                ID: false,
                cat_name: false,
                cat_apt: false,
                cat_color: false,
                cat_duration_h: false,
                cat_duration_m: false,
                cat_prevent_apt: false,
                cat_prevent_cr: false,
                cat_global: false
            },
            check: {
                ID: (v) => { return true },
                cat_name: (v) => {
                    return v.length > 0 && v.length < 21 && checkName(v, {
                        ID: ID,
                        cat_name: cat.cat_name,
                        cat_apt: cat.cat_apt,
                        cat_color: cat.cat_color,
                        cat_price: cat.cat_price,
                        cat_duration_h: splitDuration[0],
                        cat_duration_m: splitDuration[1],
                        cat_prevent_apt: cat.cat_prevent_apt,
                        cat_prevent_cr: cat.cat_prevent_cr,
                        cat_global: cat.cat_global
                    }, categoryOptions)
                },
                cat_apt: (v) => { return true },
                cat_prevent_apt: (v) => { return true },
                cat_prevent_cr: (v) => { return true },
                cat_color: (v) => { return true },
                cat_price: (v) => { return true },
                cat_duration_h: (v) => { return v >= 0 && v <= 23 },
                cat_duration_m: (v) => { return v >= 0 && v <= 59 },
                cat_global: (v) => { return true },
            },
            good: {
                ID: false,
                cat_name: false,
                cat_apt: false,
                cat_color: false,
                cat_duration_h: false,
                cat_duration_m: false,
                cat_prevent_apt: false,
                cat_prevent_cr: false,
                cat_global: false
            },
            bad: {
                ID: false,
                cat_name: false,
                cat_apt: false,
                cat_color: false,
                cat_duration_h: false,
                cat_duration_m: false,
                cat_prevent_apt: false,
                cat_prevent_cr: false,
                cat_global: false
            },
        })
        //console.log(cat)
        changeColor(cat.cat_color)

        setReloadCatCheck(false)
    }
    const loadCategories = async () => {
        let resp = await fetch(`${globalContext.get.backendUrl}/papiv1/categorys`, {
            method: 'GET',
            credentials: 'include'
        })
        let respValue = await resp.json()

        if (resp.status == 200) {
            globalContext.set(draft => { draft.categories = defCategories.concat(respValue.data) })
            setCategoryOptions(respValue.data.map(cat => ({ label: cat.cat_name, value: cat.ID })))
        }
    }
    const changeShop = (e) => {
        setSelectedOption(e)
        globalContext.set(draft => { draft.selectedShop = draft.shops.filter(sho => sho.ID == e.value)[0]; draft.Reloads.events = true })
    }
    const addCategory = async () => {
        if (!checkForm(catValues, catChecks, setCatCheks, true)) {
            return
        }

        serviceContext.set(draft => { draft.Load.isLoading = draft.Load.isLoading + 1 })
        const body = {
            cat_name: catValues.cat_name,
            cat_apt: catValues.cat_apt,
            cat_color: catValues.cat_color,
            cat_price: catValues.cat_price,
            cat_duration: getMinutes(catValues),
            cat_prevent_apt: catValues.cat_prevent_apt,
            cat_prevent_cr: catValues.cat_prevent_cr,
            cat_global: catValues.cat_global
        }

        const resp = await fetch(`${globalContext.get.backendUrl}/papiv1/categorys`, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(body)
        })
        const respValue = await resp.json()

        if (resp.status == 200) {
            loadCategories()
            closeCat()
            serviceContext.set(draft => {
                draft.Alerts.push({
                    ID: Math.random(),
                    message: textContext.get(['calendar', 'notify'], ['add_category'], textContext.value),
                    ttl: 2000
                })
            })
        } else {
            serviceContext.set(draft => {
                draft.Alerts.push({
                    ID: Math.random(),
                    message: textContext.get(['calendar', 'notify'], ['error_category'], textContext.value),
                    ttl: 2000
                })
            })
        }

        serviceContext.set(draft => { draft.Load.isLoading = draft.Load.isLoading - 1 })
    }
    const editCategory = async () => {

        if (!checkForm(catValues, catChecks, setCatCheks, true)) {
            // console.log('check non passato')
            // console.log(catChecks)
            return
        }

        serviceContext.set(draft => { draft.Load.isLoading = draft.Load.isLoading + 1 })
        const body = {
            ID: catValues.ID,
            cat_name: catValues.cat_name,
            cat_apt: catValues.cat_apt,
            cat_color: catValues.cat_color,
            cat_price: catValues.cat_price,
            cat_duration: getMinutes(catValues),
            cat_prevent_apt: catValues.cat_prevent_apt,
            cat_prevent_cr: catValues.cat_prevent_cr,
            cat_global: catValues.cat_global
        }

        const resp = await fetch(`${globalContext.get.backendUrl}/papiv1/categorys`, {
            method: 'PUT',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(body)
        })
        const respValue = await resp.json()

        if (resp.status == 200) {
            globalContext.set(draft => { draft.Reloads.events = true })
            globalContext.set(draft => { draft.Reloads.categories = true })
            //loadCategories()
            closeCat()
            serviceContext.set(draft => {
                draft.Alerts.push({
                    ID: Math.random(),
                    message: textContext.get(['calendar', 'notify'], ['category_modify'], textContext.value),
                    ttl: 2000
                })
            })
        } else {
            serviceContext.set(draft => {
                draft.Alerts.push({
                    ID: Math.random(),
                    message: textContext.get(['calendar', 'notify'], ['error_modify_category'], textContext.value),
                    ttl: 2000
                })
            })
        }

        serviceContext.set(draft => { draft.Load.isLoading = draft.Load.isLoading - 1 })
    }
    const deleteCategory = async () => {

        serviceContext.set(draft => { draft.Load.isLoading = draft.Load.isLoading + 1 })
        const resp = await fetch(`${globalContext.get.backendUrl}/papiv1/categorys`, {
            method: 'DELETE',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(catValues)
        })
        const respValue = await resp.json()

        if (resp.status == 200) {
            loadCategories()
            closeCat()
            serviceContext.set(draft => {
                draft.Alerts.push({
                    ID: Math.random(),
                    message: textContext.get(['calendar', 'notify'], ['category_delete'], textContext.value),
                    ttl: 2000
                })
            })
        } else {
            serviceContext.set(draft => {
                draft.Alerts.push({
                    ID: Math.random(),
                    message: textContext.get(['calendar', 'notify'], ['error_delete_category'], textContext.value),
                    ttl: 2000
                })
            })
        }

        serviceContext.set(draft => { draft.Load.isLoading = draft.Load.isLoading - 1 })
    }
    const closeCat = () => {
        setActiveTab("add")
        setCatValues(defCatValues)
        setCatCheks({
            touched: {
                ID: false,
                cat_name: false,
                cat_apt: false,
                cat_color: false,
                cat_duration_h: false,
                cat_duration_m: false,
                cat_prevent_apt: false,
                cat_prevent_cr: false,
                cat_global: false
            },
            check: {
                ID: (v) => { return true },
                cat_name: (v) => { return v.length > 0 && v.length < 21 && checkName(v, catValues, categoryOptions) },
                cat_apt: (v) => { return true },
                cat_prevent_apt: (v) => { return true },
                cat_prevent_cr: (v) => { return true },
                cat_color: (v) => { return true },
                cat_price: (v) => { return true },
                cat_duration_h: (v) => { return v >= 0 && v <= 23 },
                cat_duration_m: (v) => { return v >= 0 && v <= 59 },
                cat_global: (v) => { return true }
            },
            good: {
                ID: false,
                cat_name: false,
                cat_apt: false,
                cat_color: false,
                cat_duration_h: false,
                cat_duration_m: false,
                cat_prevent_apt: false,
                cat_prevent_cr: false,
                cat_global: false
            },
            bad: {
                ID: false,
                cat_name: false,
                cat_apt: false,
                cat_color: false,
                cat_duration_h: false,
                cat_duration_m: false,
                cat_prevent_apt: false,
                cat_prevent_cr: false,
                cat_global: false
            },
        })
        setShowCat(false)
    }
    const getPermission = (permission, pos = -1) => {
        if (globalContext.get) {
            if (globalContext.get.User) {
                if (globalContext.get.User.Groups) {
                    if (globalContext.get.User.Groups.length > 0) {
                        if (globalContext.get.User.Groups[0].gro_is_admin) {
                            return true
                        } else {
                            if (pos >= 0) {
                                return parseInt(globalContext.get.User.Groups[0][permission].charAt(pos))
                            } else {
                                return globalContext.get.User.Groups[0][permission]
                            }
                        }
                    }
                }
            }
        }
        return false
    }
    const resetValues = () => {
        setCatValues({
            cat_name: '',
            cat_apt: true,
            cat_color: "#cc2828",
            cat_price: 0,
            cat_duration_h: 1,
            cat_duration_m: 30,
            cat_prevent_apt: 0,
            cat_prevent_cr: 0
        })
    }
    const checkName = (name, lvalues, options) => {
        // console.log(name)
        // console.log(categoryOptions.map(cat=>cat.label))
        // console.log(catValues)
        if (options.filter(cat => cat.value !== lvalues.ID).map(cat => cat.label).includes(name)) {
            console.log('false')
            return false
        } else {
            console.log('true')
            return true
        }
    }
    const resetUserShowList = () => {
        globalContext.set(draft => {
            draft.showUsersList = [globalContext.get.User.ID]
        })
    }
    const reload = () => {
        window.location.reload()
    }

    useEffect(() => {
        getOptions()
        if (globalContext.get) {
            setCategoryOptions(globalContext.get.categories.filter(cat => cat.ID != 0).map(cat => ({ label: cat.cat_name, value: cat.ID })))
        }
        if (getPermission('gro_aer_category', 0)) {
            setActiveTab('add')
        } else if (getPermission('gro_aer_category', 1)) {
            setActiveTab('edit')
        } else {
            setActiveTab('delete')
        }
    }, [globalContext.get])
    useEffect(() => {
        setCatCheks({
            touched: {
                ID: false,
                cat_name: false,
                cat_apt: false,
                cat_color: false,
                cat_duration_h: false,
                cat_duration_m: false,
                cat_prevent_apt: false,
                cat_prevent_cr: false,
                cat_global: false
            },
            check: {
                ID: (v) => { return true },
                cat_name: (v) => { return v.length > 0 && v.length < 21 && checkName(v, catValues, categoryOptions) },
                cat_apt: (v) => { return true },
                cat_prevent_apt: (v) => { return true },
                cat_prevent_cr: (v) => { return true },
                cat_color: (v) => { return true },
                cat_price: (v) => { return true },
                cat_duration_h: (v) => { return v >= 0 && v <= 23 },
                cat_duration_m: (v) => { return v >= 0 && v <= 59 },
                cat_global: (v) => { return true }
            },
            good: {
                ID: false,
                cat_name: false,
                cat_apt: false,
                cat_color: false,
                cat_duration_h: false,
                cat_duration_m: false,
                cat_prevent_apt: false,
                cat_prevent_cr: false,
                cat_global: false
            },
            bad: {
                ID: false,
                cat_name: false,
                cat_apt: false,
                cat_color: false,
                cat_duration_h: false,
                cat_duration_m: false,
                cat_prevent_apt: false,
                cat_prevent_cr: false,
                cat_global: false
            },
        })
    }, [categoryOptions])
    useEffect(() => {
        if (resetSwitch) {
            setResetSwitch(false)
        }
    }, [resetSwitch])
    useEffect(() => {
        checkForm(catValues, catChecks, setCatCheks)
        setResetColors(true)
        setResetSwitch(true)
    }, [catValues])
    useEffect(() => {
        if (resetColors) {
            setResetColors(false)
        }
    }, [resetColors])
    useEffect(() => {
        if (!reloadCatCheck) {
            setReloadCatCheck(true)
        }
    }, [reloadCatCheck])
    useEffect(() => {
        setReloadCatCheck(true)
        setResetColors(false)
        setResetSwitch(false)
    }, [showCat])

    return (

        <Toolbar.FlexibleSpace className='calendar-toolbar'>
            <div className='calendar-toolbar-category' >
                {getPermission('gro_aer_category', 0) || getPermission('gro_aer_category', 1) || getPermission('gro_aer_category', 2) ? (
                    <button type="button" className='nac-button calendar-category-button' onClick={() => setShowCat(true)}>
                        <RiPriceTag3Line size={`24pt`} />
                    </button>
                ) : (<></>)}
            </div>
            {globalContext.get.Agency.age_max_users != 1 ?
                <div className='calendar-toolbar-users' >
                    <button type="button" className='nac-button calendar-users-left-button' onClick={() => setShowUserFilter(true)}>
                        <RiFilter2Line size={`24pt`} />
                    </button>
                    <button type="button" className='nac-button calendar-users-right-button' onClick={resetUserShowList}>
                        <RiEraserLine size={`24pt`} />
                    </button>
                </div> : <></>}

            <div className='calendar-toolbar-category' >
                <button type="button" className='nac-button calendar-category-button' onClick={reload}>
                    <RiLoopLeftFill size={`24pt`} />
                </button>
            </div>
            <div className='calendar-toolbar-select'>
                {getPermission('gro_view_shops') && (
                    <Select
                        style={{ width: '100%' }}
                        className='calendar-shop-select'
                        placeholder="Seleziona sedi"
                        options={options}
                        value={selectedOption}
                        onChange={e => changeShop(e)}
                    />
                )}
            </div>
            <Modal show={showCat} onHide={closeCat}>
                <ModalHeader closeButton>
                    <ModalTitle className='nac-title'>{textContext.get(['calendar', 'category'], ['title'], textContext.value)}</ModalTitle>
                </ModalHeader>
                <Tabs
                    defaultActiveKey="add"
                    id="uncontrolled-tab-example"
                    className="mb-1 mt-3 mx-1"
                    activeKey={activeTab}
                    onSelect={(k) => { setActiveTab(k); resetValues() }}
                >
                    {getPermission('gro_aer_category', 0) ? (
                        <Tab eventKey="add" title={textContext.get(['calendar', 'category', 'add_category'], ['title'], textContext.value)}>
                            <ModalBody className='' >
                                <Form>
                                    <Row className='mt-4'>
                                        <InputGroup hasValidation>
                                            <InputGroup.Text
                                                style={{ borderTopRightRadius: '0px', borderBottomRightRadius: '0px' }}
                                            >{textContext.get(['calendar', 'category', 'edit_category'], ['category_name'], textContext.value)}</InputGroup.Text>
                                            <FormControl
                                                type='text'
                                                placeholder={textContext.get(['calendar', 'category', 'edit_category'], ['title_placeholder'], textContext.value)}
                                                value={catValues.cat_name}
                                                onChange={(e) => setCatValues(draft => { draft.cat_name = e.target.value })}
                                                onFocus={(e) => setCatCheks(draft => { draft.touched.cat_name = true })}
                                                isValid={catChecks.good.cat_name}
                                                isInvalid={catChecks.bad.cat_name}
                                            />
                                        </InputGroup>
                                    </Row>
                                    <Row className='mt-4'>
                                        <InputGroup hasValidation>
                                            <InputGroup.Text>{textContext.get(['calendar', 'category', 'add_category'], ['cateogry_time'], textContext.value)}</InputGroup.Text>
                                            <GoodNumber
                                                value={catValues.cat_duration_h}
                                                min={0}
                                                max={23}
                                                classes='form-control'
                                                style={{ maxWidth: `${globalContext.get.Theme.text_size * 6}pt` }}
                                                onChange={(e) => setCatValues(draft => { draft.cat_duration_h = e })}
                                                onFocus={(e) => setCatCheks(draft => { draft.touched.cat_duration_h = true })}
                                                isValid={catChecks.good.cat_duration_h}
                                                isInvalid={catChecks.bad.cat_duration_h}
                                            />
                                            <InputGroup.Text className='input-group-text-squared'>h</InputGroup.Text>
                                            <GoodNumber
                                                value={catValues.cat_duration_m}
                                                min={0}
                                                max={59}
                                                classes='form-control'
                                                style={{ maxWidth: `${globalContext.get.Theme.text_size * 5}pt`, borderRadius: '0px' }}
                                                onChange={(e) => setCatValues(draft => { draft.cat_duration_m = e })}
                                                onFocus={(e) => setCatCheks(draft => { draft.touched.cat_duration_m = true })}
                                                isValid={catChecks.good.cat_duration_m}
                                                isInvalid={catChecks.bad.cat_duration_m}

                                            />
                                            <InputGroup.Text>m</InputGroup.Text>
                                        </InputGroup>
                                    </Row>
                                    <Row className='mt-4'>
                                        <Col className='mx-2'>
                                            <GoodSwitch
                                                label={textContext.get(['calendar', 'category', 'add_category'], ['glo'], textContext.value)}
                                                value={catValues.cat_global}
                                                //reset={resetSwitch}
                                                onChange={(e) => { setCatValues(draft => { draft.cat_global = e }) }}
                                            />
                                        </Col>
                                        <Col xs={1}>
                                            <AiOutlineQuestionCircle
                                                title={textContext.get(['calendar', 'category', 'add_category'], ['glo2'], textContext.value)}
                                                style={{ cursor: 'help' }}
                                            />
                                        </Col>
                                    </Row>
                                    <Row className='mt-4'>
                                        <Col className='ms-2 me-3'>
                                            <GoodSwitch
                                                label={textContext.get(['calendar', 'category', 'add_category'], ['is_apt'], textContext.value)}
                                                value={catValues.cat_apt}
                                                //reset={resetSwitch}
                                                onChange={(e) => { setCatValues(draft => { draft.cat_apt = e; draft.cat_prevent_apt = 0 }); }}
                                            />
                                        </Col>
                                    </Row>
                                    {catValues.cat_apt ? (
                                        <>
                                            <Row className='mt-4'>
                                                <Col className='mx-2 '>
                                                    <GoodSwitch
                                                        label={textContext.get(['calendar', 'category', 'add_category'], ['prev_pren'], textContext.value)}
                                                        value={catValues.cat_prevent_cr}
                                                        //reset={resetSwitch}
                                                        invertValue={true}
                                                        onChange={(e) => { setCatValues(draft => { draft.cat_prevent_cr = e; draft.cat_prevent_apt = 0 }); }}
                                                    />
                                                </Col>
                                                <Col xs={1}>
                                                    <AiOutlineQuestionCircle
                                                        title={textContext.get(['calendar', 'category', 'add_category'], ['prev_pren_help'], textContext.value)}
                                                        style={{ cursor: 'help' }}
                                                    />
                                                </Col>
                                            </Row>
                                            {catValues.cat_prevent_cr ? (<></>) : (
                                                <Row className='mt-4'>
                                                    {/* <GoodCheck
                                                    label="Previeni prenotazione di altri appuntamenti?"
                                                    defaultChecked={catValues.cat_prevent_apt}
                                                    helpTitle={textContext.get(['calendar', 'category','add_category'], ['description'], textContext.value)}
                                                    onChange={(e) => { setCatValues(draft => { draft.cat_prevent_apt = e.target.value?2:0; }) }}
                                                /> */}
                                                    <Col className='mx-2 '>
                                                        <GoodSwitch
                                                            label={textContext.get(['calendar', 'category', 'add_category'], ['cont'], textContext.value)}
                                                            value={catValues.cat_prevent_apt}
                                                            //reset={resetSwitch}
                                                            onChange={(e) => { setCatValues(draft => { draft.cat_prevent_apt = e ? 2 : 0; }); }}
                                                        />
                                                    </Col>
                                                    <Col xs={1}>
                                                        <AiOutlineQuestionCircle
                                                            title={textContext.get(['calendar', 'category', 'add_category'], ['cont_desc'], textContext.value)}
                                                            style={{ cursor: 'help' }}
                                                        />
                                                    </Col>
                                                </Row>
                                            )}
                                            <Row className='mt-4'>
                                                <InputGroup hasValidation>
                                                    <InputGroup.Text>{textContext.get(['event', 'info_event'], ['price'], textContext.value)} </InputGroup.Text>
                                                    <GoodNumber
                                                        value={catValues.cat_price}
                                                        min={0}
                                                        classes='form-control'
                                                        onChange={(e) => setCatValues(draft => { draft.cat_price = e })}
                                                    />
                                                    <InputGroup.Text>CHF</InputGroup.Text>
                                                </InputGroup>
                                            </Row>
                                        </>
                                    ) : (
                                        <Row className='mt-4'>
                                            <Col className='mx-2 '>
                                                <GoodSwitch
                                                    label={textContext.get(['calendar', 'category', 'add_category'], ['prev'], textContext.value)}
                                                    value={catValues.cat_prevent_apt}
                                                    //reset={resetSwitch}
                                                    onChange={(e) => { setCatValues(draft => { draft.cat_prevent_apt = e; }); }}
                                                />
                                            </Col>
                                            <Col xs={1}>
                                                <AiOutlineQuestionCircle
                                                    title={textContext.get(['calendar', 'category', 'add_category'], ['description'], textContext.value)}
                                                    style={{ cursor: 'help' }}
                                                />
                                            </Col>
                                        </Row>
                                    )}
                                    <Row className='mt-4'>
                                        <InputGroup>
                                            <InputGroup.Text>{textContext.get(['calendar', 'category', 'add_category'], ['color'], textContext.value)}</InputGroup.Text>
                                            {!resetColors && (
                                                <FormControl
                                                    type='color'
                                                    id='colorPicker'
                                                    defaultValue={catValues.cat_color}
                                                    onChange={(e) => changeColor(e)}
                                                    onBlur={(e) => { setCatValues(draft => { draft.cat_color = colorRef.current }); }}
                                                />
                                            )}
                                        </InputGroup>
                                    </Row>
                                </Form>
                            </ModalBody>
                            <ModalFooter className='d-block'>
                                <Row>
                                    <Col xs={9} >
                                    </Col>
                                    <Col xs={2} className='d-flex justify-content-center'>
                                        <button type="button" className='nac-button' onClick={closeCat}>
                                            <RiCloseLine size={`24pt`} />
                                        </button>
                                    </Col>
                                    <Col xs={1} className='d-flex justify-content-center'>
                                        <button type="button" className='nac-button' onClick={() => addCategory()}>
                                            <RiCheckLine size={`24pt`} />
                                        </button>
                                    </Col>
                                </Row>
                            </ModalFooter>
                        </Tab>
                    ) : (<></>)}
                    {getPermission('gro_aer_category', 1) ? (
                        <Tab eventKey="edit" title={textContext.get(['calendar', 'category', 'edit_category'], ['title'], textContext.value)}>
                            <ModalBody className='' >
                                <Form>
                                    <Row className='mt-4'>
                                        <Form.Label className='light-color'>{textContext.get(['calendar', 'category', 'edit_category'], ['select_category'], textContext.value)}</Form.Label>
                                        <Select
                                            id='select-pdp'
                                            components={animatedComponents}
                                            options={categoryOptions}
                                            value={{ label: catValues.cat_name, value: catValues.ID }}
                                            onChange={(e) => loadCatValues(e.value)}
                                        />
                                    </Row>
                                    <hr />
                                    <Row className='mt-4'>
                                        <InputGroup>
                                            <InputGroup.Text>{textContext.get(['calendar', 'category', 'add_category'], ['category_name'], textContext.value)}</InputGroup.Text>
                                            <FormControl
                                                type='text'
                                                placeholder={textContext.get(['calendar', 'category', 'add_category'], ['title_placeholder'], textContext.value)}
                                                value={catValues.cat_name}
                                                onChange={(e) => setCatValues(draft => { draft.cat_name = e.target.value })}
                                                onFocus={(e) => setCatCheks(draft => { draft.touched.cat_name = true })}
                                                isValid={catChecks.good.cat_name}
                                                isInvalid={catChecks.bad.cat_name}
                                            />
                                        </InputGroup>
                                    </Row>
                                    <Row className='mt-4'>
                                        <InputGroup hasValidation>
                                            <InputGroup.Text>{textContext.get(['calendar', 'category', 'edit_category'], ['time'], textContext.value)}</InputGroup.Text>
                                            <GoodNumber
                                                value={catValues.cat_duration_h}
                                                min={0}
                                                max={23}
                                                classes='form-control'
                                                style={{ maxWidth: `${globalContext.get.Theme.text_size * 6}pt` }}
                                                onChange={(e) => setCatValues(draft => { draft.cat_duration_h = e })}
                                                onFocus={(e) => setCatCheks(draft => { draft.touched.cat_duration_h = true })}
                                                isValid={catChecks.good.cat_duration_h}
                                                isInvalid={catChecks.bad.cat_duration_h}
                                            />
                                            <InputGroup.Text className='input-group-text-squared'>h</InputGroup.Text>
                                            <GoodNumber
                                                value={catValues.cat_duration_m}
                                                min={0}
                                                max={59}
                                                classes='form-control'
                                                style={{ maxWidth: `${globalContext.get.Theme.text_size * 5}pt`, borderRadius: '0px' }}
                                                onChange={(e) => setCatValues(draft => { draft.cat_duration_m = e })}
                                                onFocus={(e) => setCatCheks(draft => { draft.touched.cat_duration_m = true })}
                                                isValid={catChecks.good.cat_duration_m}
                                                isInvalid={catChecks.bad.cat_duration_m}
                                            />
                                            <InputGroup.Text>m</InputGroup.Text>
                                        </InputGroup>
                                    </Row>
                                    <Row className='mt-4'>
                                        <Col className='mx-2'>
                                            <GoodSwitch
                                                label={textContext.get(['calendar', 'category', 'add_category'], ['glo'], textContext.value)}
                                                value={catValues.cat_global}
                                                //reset={resetSwitch}
                                                onChange={(e) => { setCatValues(draft => { draft.cat_global = e }) }}
                                            />
                                        </Col>
                                        <Col xs={1}>
                                            <AiOutlineQuestionCircle
                                                title={textContext.get(['calendar', 'category', 'add_category'], ['glo2'], textContext.value)}
                                                style={{ cursor: 'help' }}
                                            />
                                        </Col>
                                    </Row>
                                    {reloadCatCheck ? (
                                        <Row className='mt-4' style={{ height: "2vh" }}>
                                            <Col className='ms-2 me-3'>
                                                <GoodSwitch
                                                    className='light-color'
                                                    label={textContext.get(['calendar', 'category', 'edit_category'], ['is_apt'], textContext.value)}
                                                    value={catValues.cat_apt}
                                                    onChange={(e) => setCatValues(draft => { draft.cat_apt = e; draft.cat_prevent_apt = 0 })}
                                                />
                                            </Col>
                                        </Row>
                                    ) : (
                                        <Row className='mt-4' style={{ height: "2vh" }}>
                                            <Col className='ms-2 me-3'>
                                            </Col>
                                        </Row>
                                    )}
                                    {catValues.cat_apt ? (
                                        <>
                                            <Row className='mt-4'>
                                                <Col className='ms-2 '>
                                                    <GoodSwitch
                                                        label={textContext.get(['calendar', 'category', 'edit_category'], ['prev_pren'], textContext.value)}
                                                        value={catValues.cat_prevent_cr}
                                                        //reset={resetSwitch}
                                                        invertValue={true}
                                                        onChange={(e) => { setCatValues(draft => { draft.cat_prevent_cr = e; draft.cat_prevent_apt = 0 }); }}
                                                    />
                                                </Col>
                                                <Col xs={1}>
                                                    <AiOutlineQuestionCircle
                                                        title={textContext.get(['calendar', 'category', 'add_category'], ['prev_pren_help'], textContext.value)}
                                                        style={{ cursor: 'help' }}
                                                    />
                                                </Col>
                                            </Row>
                                            {catValues.cat_prevent_cr ? (<></>) : (
                                                <Row className='mt-4'>
                                                    {/* <GoodCheck
                                                    label="Previeni prenotazione di altri appuntamenti?"
                                                    defaultChecked={catValues.cat_prevent_apt}
                                                    helpTitle={textContext.get(['calendar', 'category','add_category'], ['description'], textContext.value)}
                                                    onChange={(e) => { setCatValues(draft => { draft.cat_prevent_apt = e.target.value?2:0; }) }}
                                                /> */}
                                                    <Col className='mx-2 '>
                                                        <GoodSwitch
                                                            label={textContext.get(['calendar', 'category', 'add_category'], ['cont'], textContext.value)}
                                                            value={catValues.cat_prevent_apt}
                                                            //reset={resetSwitch}
                                                            onChange={(e) => { setCatValues(draft => { draft.cat_prevent_apt = e ? 2 : 0; }); }}
                                                        />
                                                    </Col>
                                                    <Col xs={1}>
                                                        <AiOutlineQuestionCircle
                                                            title={textContext.get(['calendar', 'category', 'add_category'], ['cont_desc'], textContext.value)}
                                                            style={{ cursor: 'help' }}
                                                        />
                                                    </Col>
                                                </Row>
                                            )}
                                            <Row className='mt-4'>
                                                <InputGroup hasValidation>
                                                    <InputGroup.Text>{textContext.get(['event', 'info_event'], ['price'], textContext.value)}</InputGroup.Text>
                                                    <GoodNumber
                                                        value={catValues.cat_price}
                                                        min={0}
                                                        classes='form-control'
                                                        onChange={(e) => setCatValues(draft => { draft.cat_price = e })}
                                                    />
                                                    <InputGroup.Text>CHF</InputGroup.Text>
                                                </InputGroup>
                                            </Row>
                                        </>
                                    ) : (
                                        <Row className='mt-4'>
                                            <Col className='mx-2 '>
                                                <GoodSwitch
                                                    label={textContext.get(['calendar', 'category', 'add_category'], ['prev'], textContext.value)}
                                                    value={catValues.cat_prevent_apt}
                                                    //reset={resetSwitch}
                                                    onChange={(e) => { setCatValues(draft => { draft.cat_prevent_apt = e; }); }}
                                                />
                                            </Col>
                                            <Col xs={1}>
                                                <AiOutlineQuestionCircle
                                                    title={textContext.get(['calendar', 'category', 'add_category'], ['description'], textContext.value)}
                                                    style={{ cursor: 'help' }}
                                                />
                                            </Col>
                                        </Row>
                                    )}
                                    <Row className='mt-4'>
                                        <InputGroup>
                                            <InputGroup.Text>{textContext.get(['calendar', 'category', 'edit_category'], ['color'], textContext.value)}</InputGroup.Text>
                                            {!resetColors && (
                                                <FormControl
                                                    type='color'
                                                    id='colorPicker'
                                                    defaultValue={catValues.cat_color}
                                                    onChange={(e) => changeColor(e)}
                                                    onBlur={(e) => { setCatValues(draft => { draft.cat_color = colorRef.current }); console.log(e) }}
                                                />
                                            )}
                                        </InputGroup>
                                    </Row>
                                </Form>
                            </ModalBody>
                            <ModalFooter className='d-block'>
                                <Row>
                                    <Col xs={9} >
                                    </Col>
                                    <Col xs={2} className='d-flex justify-content-center'>
                                        <button type="button" className='nac-button' onClick={closeCat}>
                                            <RiCloseLine size={`24pt`} />
                                        </button>
                                    </Col>
                                    <Col xs={1} className='d-flex justify-content-center'>
                                        <button type="button" className='nac-button' onClick={() => editCategory()}>
                                            <RiCheckLine size={`24pt`} />
                                        </button>
                                    </Col>
                                </Row>
                            </ModalFooter>
                        </Tab>
                    ) : (<></>)}
                    {getPermission('gro_aer_category', 2) ? (
                        <Tab eventKey="delete" title={textContext.get(['calendar', 'category', 'delete_category'], ['title'], textContext.value)}>
                            <ModalBody className='' >
                                <Form>
                                    <Row className='mt-4'>
                                        <Form.Label className='light-color'>{textContext.get(['calendar', 'category', 'delete_category'], ['select_category'], textContext.value)}</Form.Label>
                                        <Select
                                            id='select-pdp'
                                            components={animatedComponents}
                                            options={categoryOptions}
                                            value={{ label: catValues.cat_name, value: catValues.ID }}
                                            onChange={(e) => loadCatValues(e.value)}
                                        />
                                    </Row>
                                    <hr />
                                    <p>
                                        {textContext.get(['calendar', 'category', 'delete_category'], ['text_delete'], textContext.value)}
                                    </p>
                                </Form>
                            </ModalBody>
                            <ModalFooter className='d-block'>
                                <Row>
                                    <Col xs={9} >
                                    </Col>
                                    <Col xs={2} className='d-flex justify-content-center'>
                                        <button type="button" className='nac-button' onClick={closeCat}>
                                            <RiCloseLine size={`24pt`} />
                                        </button>
                                    </Col>
                                    <Col xs={1} className='d-flex justify-content-center'>
                                        <button type="button" className='nac-button' onClick={() => deleteCategory()}>
                                            <RiCheckLine size={`24pt`} />
                                        </button>
                                    </Col>
                                </Row>
                            </ModalFooter>
                        </Tab>
                    ) : (<></>)}
                </Tabs>
            </Modal>
            <UserFilterModal show={showUserFilter} setShow={setShowUserFilter} />
        </Toolbar.FlexibleSpace>
    )
}
export default CustomFlexibleSpace